export default "__VITE_ASSET__W7Iryrvq__"